import { memo } from 'react';

import NoFilesIcon from '@/assets/no-files-icon.svg?react';
import { Logo, LogoProps } from '@/components/core';

import { merge } from '../utils';

export type NoFilesLogoProps = LogoProps;

const INoFilesLogo = ({ className, ...rest }: NoFilesLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <NoFilesIcon className="size-5" />
    </Logo>
  );
};

export const NoFilesLogo = memo(INoFilesLogo) as typeof INoFilesLogo;
